import { useMemo } from 'react';

export const useMinimizedTreeData = <DataT>(
  isSidebarMinimized: boolean,
  treeData: DataT[],
  minifiedTreeSourceData?: DataT[]
) => {
  const adjustedTreeData = useMemo(() => {
    if (isSidebarMinimized) {
      return (minifiedTreeSourceData || treeData)?.map((node) => ({
        ...node,
        isLeaf: true,
        children: [],
      }));
    }
    return treeData;
  }, [treeData, isSidebarMinimized, minifiedTreeSourceData]);

  return adjustedTreeData;
};
